import { useState } from "react";
import { Box, Button, IconButton, Modal, Stack, TextField, Typography } from "@mui/material";
import { setShowalert } from "../../redux/actions/actions";
import { useDispatch, useSelector } from "react-redux";
import { SAVE_DATA_ISSUES } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import CloseIcon from "@mui/icons-material/Close";
import { English } from "../../constant/EnglishFallback";
import { BIBlue } from "../../assets/helpers";

export const SendFeedbackModal = (props) => {
  const [feedbackDescription, setFeedbackDescription] = useState("");
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const dispatch = useDispatch();
  const {
    TEXT_SEND_FEEDBACK = English?.SendFeedback?.TEXT_SEND_FEEDBACK,
    TEXT_SEND_FEEDBACK_THANK_YOU = English?.SendFeedback?.TEXT_SEND_FEEDBACK_THANK_YOU,
    TEXT_SEND_FFEDBACK_DESC_1 = English?.SendFeedback?.TEXT_SEND_FFEDBACK_DESC_1,
    TEXT_FEEDBACK = English?.SendFeedback?.TEXT_FEEDBACK,
    TEXT_SEND_FFEDBACK_DESC_2 = English?.SendFeedback?.TEXT_SEND_FFEDBACK_DESC_2,
    BUTTON_TEXT_SUBMIT = English?.SendFeedback?.BUTTON_TEXT_SUBMIT
  } = multiLanguageData?.SendFeedback || {};

  async function handleSubmitClick() {
    const reportObj = {
      UserId: Number(loginData?.userInformation?.UserId),
      ReturnRecordId: false,
      ReturnRecordError: true,
      SaveList: [
        {
          Id: 0,
          RecordId: 0,
          DataSource: "feedback",
          DataIncorrect: false,
          DataOffensive: false,
          DataOther: false,
          DataComments: feedbackDescription,
          ModifiedBy: Number(loginData?.userInformation?.UserId)
        }
      ]
    };
    let reportRes = await Postrequestcall(SAVE_DATA_ISSUES, reportObj, loginData?.accessToken);
    if (reportRes?.data?.message === "OK") {
      let alertObj = {
        showAlert: true,
        title: "",
        text: TEXT_SEND_FEEDBACK_THANK_YOU
      };
      dispatch(setShowalert(alertObj));
      setFeedbackDescription("");
      props?.onClose();
    }
  }

  return (
    <>
      <Modal open={props?.isOpen}>
        <Box className="user-modal-responsive">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography variant="h6">{TEXT_SEND_FEEDBACK}</Typography>
            <Stack direction={"row"}>
              <IconButton onClick={() => props?.onClose()}>
                <CloseIcon />
              </IconButton>
            </Stack>
          </Box>
          <Stack spacing={1} sx={{ alignItems: "center" }}>
            <Typography variant="body1">{TEXT_SEND_FFEDBACK_DESC_1}</Typography>
            <TextField
              multiline
              rows={4}
              variant="outlined"
              fullWidth
              placeholder={TEXT_FEEDBACK}
              value={feedbackDescription}
              onChange={(e) => {
                let inputValue = e.target.value;
                inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                setFeedbackDescription(inputValue);
              }}
            />
            <Stack spacing={1} sx={{ pt: 2,  alignItems: "center" }} >
              <Typography variant="body1">{TEXT_SEND_FFEDBACK_DESC_2}</Typography>
              <Typography variant="body1" sx={{ color: "primary" }}>
                <a
                  style={{ textDecoration: "none", color: BIBlue }}
                  href="mailto:info@mybuilderid.com">
                  info@mybuilderid.com
                </a>
              </Typography>
            </Stack>

            <Box sx={{ display: "flex" }} width={"100%"}>
              <Button
                variant="contained"
                fullWidth
                color="primary"
                disabled={!feedbackDescription}
                onClick={handleSubmitClick}>
                {BUTTON_TEXT_SUBMIT}
              </Button>
            </Box>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};
